module.exports = __webpack_public_path__ + "images/video-thumb-nada.jpg";